import { SetState } from "shared/types/general";
import { formatPhone } from "shared/lib/formatPhone";
import { LoginApi } from "../api";
import { ROUTES_PATH } from "shared/constants/routesPath";
import { showError } from "shared/lib/showError";
import { setAuthKey } from "shared/redux/reducers/UserSlice";
import { fetchUserInfo } from "shared/redux/asyncActions/fetchUserInfo";
import { LoginDTO } from "../api/models";

interface handleLoginProps {
  setDataSending: SetState<boolean>;
  dispatch: any;
  phone: string;
  code: string;
  setCookie: any;
  navigate: any;
  promocode?: string;
}

export const handleLogin: (props: handleLoginProps) => void = ({
  setDataSending,
  dispatch,
  phone,
  code,
  setCookie,
  navigate,
  promocode,
}) => {
  setDataSending(true);

  const data: LoginDTO = {
    msisdn: formatPhone(phone),
    password: code,
  };

  if (promocode) data.promocode = promocode;

  LoginApi(data)
    .then((res) => {
      dispatch(setAuthKey(res.auth_key));
      dispatch(fetchUserInfo({ auth_key: res.auth_key, user_id: res.user_id }));
      const timestamp = new Date().getTime();
      //expires after one year
      const expire = timestamp + 60 * 60 * 24 * 1000 * 365 * 1;
      const expireDate = new Date(expire);

      setCookie("auth_key", res.auth_key, {
        expires: expireDate,
        secure: false,
      });
      setCookie("user_id", res.user_id, {
        expires: expireDate,
        secure: false,
      });

      navigate(ROUTES_PATH.ACCOUNT);
    })
    .catch((e) => {
      showError(e, dispatch);
    })
    .finally(() => setDataSending(false));
};
